/**
 * Перечень услуг
 *
 * @param {Object} params
 * @param {String} params.urlApi - url обращения к api услуг
 * @param {String} params.servicesList - список врачей
 * @param {String} params.citySelect - селект города
 * @param {String} params.choiceClinic - выбор клиники
 * @param {String} params.servicesServiceField - поле поиска услуги
 * @param {String} params.servicesServiceClear - кнопка очистки услуги
 * @param {String} params.forChildsField - селект выбора врача детский/взрослый
 */
$.fn.servicesListClinic = function (params) {

    const $self = $(this);
    const $servicesList = $self.find(params.servicesList);
    const $forChildsField = params.forChildsField;
    const $servicesServiceField = params.servicesServiceField;
    const $servicesServiceClear = $self.find(params.servicesServiceClear);
    const urlApi = $self.attr(params.urlApi);
    const citySelect = params.citySelect;
    const choiceClinic = params.choiceClinic;

    let service = '';
    let forChilds = false;
    let activeClinic = 0;

    /**
     * Переключатель врач - детский/взрослый
     */
    $self.find($forChildsField).click(function () {

        forChilds = !forChilds;
        update();
    });

    /**
     * Поле названия услуги
     */
    $self.find($servicesServiceField).on('paste keyup change', function () {

        let value = $(this).val();

        if (value !== service) {
            service = value;
            update();
        }
    });

    /**
     * Очистка поля названия услуги
     */
    $servicesServiceClear.click(function () {

        service = '';
        update();
    });

    /**
     * Выбор клиники
     */
    $self.on('click', choiceClinic, function () {

        let clinic = +$(this).attr('data-value');

        if (clinic !== activeClinic) {
            activeClinic = clinic;
            update();
        }
    });

    /**
     * Рендер списка услуг
     */
    const update = function () {

        let cityId = $self.find(citySelect).val();

        $.ajax({
            method: 'GET',
            url: urlApi,
            data: {
                for_childs: forChilds,
                city_id: cityId,
                clinic_id: activeClinic,
                service: service
            }
        }).done(function (res) {
            $servicesList.html(res);
        }).fail(function (error) {
            console.log(error);
        });

    };

    return this;
};

// инициализация
const init = function () {

    $('#services-list-module').servicesListClinic({
        urlApi: 'data-url-api',
        servicesList: $('#services-list'),
        servicesServiceField: $('[data-services-service-field="true"]'),
        servicesServiceClear: $('[data-services-service-clear="true"]'),
        citySelect: '.city-switcher-options .active:first',
        forChildsField: $('[data-services-for-childs-field="true"]'),
        choiceClinic: '[data-choice-clinic="true"] .c-select-option',
    });
};

if ($('#services-list-module').length > 0) {
    init();
}